import React from 'react';

import ProficiencyBadge from '@core/components/proficiencybadge/ProficiencyBadge';
import StarRate from '@core/components/starrate/StarRate';
import Link from 'next/link';

import classes from './FeaturedCourseCard.module.scss';



const FeaturedCourseCard = ({ data }) => {
    return (
        <Link href={`courses/${data.id}/${data.slug}`}>
            <div className={classes['wrapper']}>
                <div className={classes['card-img']} style={{ backgroundImage: `url(${data.image})` }}></div>
                <div className={classes['card-content']}>
                    <h5>{data.title}</h5>
                    <div className='d-flex justify-content-between align-items-center mt-3'>
                        <StarRate rate_average={data?.rate_average} />
                        <ProficiencyBadge proficiency={data?.proficiency} />
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default FeaturedCourseCard;